/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DataItemBinningAPI
 * @hideconstructor
 * 
 * @classdesc
 * Represents the binning settings under the data item
 */
define([], () => {
	class DataItemBinningAPI { }
	return DataItemBinningAPI;
});
